import Class from '@/utils/class'
import Sha256 from '@/utils/sha256'
import tangoSocket from './tangoSocket'

export default Class.extend('tangoMessage', tangoSocket, {
  __messages: {
    2001: 'notifUpdateContract',
    1013: 'updateUser',
    1006: 'countryList'
  },
  __clockDrift: 0,
  __heartbeatTimer : null,

  construct () {
    this.__subscriptions = {}
  },

  connect (endpoint) {
    return this.__connect('TANGO', endpoint)
  },

  close () {
    this.__subscriptions = {}
    this.stopHeartbeatTimer()
    this.__disconnect()
  },

  logOut () {
    this.iRiskMonitorUnsubscribeForce()

    return this.request({
      MTI: 1002
    })
  },

  startHeartbeatTimer: function(heartbeatDelay) { //heartbeatDelay : interval in seconds
    this.stopHeartbeatTimer()
    if (heartbeatDelay>0) {
      this.heartBeat()
      this.__heartbeatTimer = setInterval(() => this.heartBeat(), heartbeatDelay*1000)
    }
  },

  stopHeartbeatTimer: function() {
    if (this.__heartbeatTimer)
      clearInterval(this.__heartbeatTimer)
    this.__heartbeatTimer = null
  },

  heartBeat () {
    return this.request({
      MTI: 1041
    })
  },

  subscribe (evt, self, cb) {
    (this.__subscriptions[evt] || (this.__subscriptions[evt] = [])).push({
      self: self,
      cb: cb
    })
  },

  unSubscribe (evt, self, cb) {
    if (this.__subscriptions[evt]) {
      for (let i = 0; i < this.__subscriptions[evt].length; i++) {
        let sub = this.__subscriptions[evt][i]
        if ((sub.self === self) && (sub.cb === cb)) {
          this.__subscriptions[evt].splice(i, 1)
          if (!this.__subscriptions[evt].length) delete this.__subscriptions[evt]
          break
        }
      }
    }
  },

  iRiskMonitorSubscribe (conditions, self, cb) {
    let cond = Object.assign({ MTI: 4985 }, conditions)
    return this.request(cond).then(rep => {
      if (rep.resultCode === 0) {
        this.subscribe('IRiskHubUpdate', self, cb)
      }
      return rep
    })
  },

  iRiskMonitorUnsubscribe (self, cb) {
    return this.request({
      MTI: 4985,
      isDeleted: 1
    }).then(rep => {
      if (rep.resultCode === 0) {
        this.unSubscribe('IRiskHubUpdate', self, cb)
      }
      return rep
    })
  },

  iRiskMonitorUnsubscribeForce () {
    delete this.__subscriptions['IRiskHubUpdate']
    return this.request({
      MTI: 4985,
      isDeleted: 1
    })
  },

  onConnect () {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[TANGO] connected:', this.__socket.endpoint())
    }
    this.fire('tangoConnected')
  },

  onClose () {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[TANGO] disconnected')
    }
    this.fire('tangoDisconnected')
  },

  isConnected () {
    return this.__isConnected()
  },

  onMessage (data) {
    if (data.MTI === 2001) {
      if (data.contractList && data.contractList.length === 1) {
        if (this.__subscriptions['contractUpdated']) {
          for (let i = 0; i < this.__subscriptions['contractUpdated'].length; i++) {
            this.__subscriptions['contractUpdated'][i].cb.call(this.__subscriptions['contractUpdated'][i].self, data.contractList[0])
          }
        }
      }
    }
    else if (data.MTI === 2002) {
      if (data.contractId) {
        if (this.__subscriptions['commentUpdated']) {
          for (let i = 0; i < this.__subscriptions['commentUpdated'].length; i++) {
            this.__subscriptions['commentUpdated'][i].cb.call(this.__subscriptions['commentUpdated'][i].self, data)
          }
        }
      }
    }
    else if (data.MTI === 2003) {
      if (this.__subscriptions['newUnreadMessageCount']) {
        for (let i = 0; i < this.__subscriptions['newUnreadMessageCount'].length; i++) {
          this.__subscriptions['newUnreadMessageCount'][i].cb.call(this.__subscriptions['newUnreadMessageCount'][i].self, data)
        }
      }
    }
    else if (data.MTI === 4986) {
      if (this.__subscriptions['IRiskHubUpdate']) {
        for (let i = 0; i < this.__subscriptions['IRiskHubUpdate'].length; i++) {
          this.__subscriptions['IRiskHubUpdate'][i].cb.call(this.__subscriptions['IRiskHubUpdate'][i].self, data)
        }
      }
    }
    else if (data.MTI === 4983) {
      if (this.__subscriptions['notificationUpdate']) {
        for (let i = 0; i < this.__subscriptions['notificationUpdate'].length; i++) {
          this.__subscriptions['notificationUpdate'][i].cb.call(this.__subscriptions['notificationUpdate'][i].self, data)
        }
      }
    }
    else if (this.__messages[data.MTI]) {
      this.fire(this.__messages[data.MTI], data)
    }
  },

  login (login, password) {
    return this.request({
      MTI: 1001,
      login: login,
      netDevice: navigator.userAgent,
      // password: password
      password: Sha256.hash(password)
    })
  },

  currencyList () {
    return this.request({MTI: 4981 })
  },

  forgotPassword (email) {
    return this.request({
      MTI: 1008,
      userEmail: email
    })
  },

  changePassword (data) {
    let cond = Object.assign({ MTI: 1010 }, data)
    cond.password = Sha256.hash(cond.password)
    cond.oldPwd = Sha256.hash(cond.oldPwd)
    delete cond.confirmPwd
    return this.request(cond)
  },

  createAccount (user) {
    let cond = {
      MTI: 1005,
      userInfos: Object.assign({}, user)
    }
    cond.userInfos.password = Sha256.hash(cond.userInfos.password)
    return this.request(cond)
  },

  regenerateAccountCode (email) {
    return this.request({
      MTI: 1006,
      userEmail: email
    })
  },

  validateUser (data) {
    let cond = Object.assign({ MTI: 1007 }, data)
    return this.request(cond)
  },

  getUserInfoByEmail (data) {
    return this.request({
      MTI: 1009,
      userInfos: data
    })
  },

  getCountryList () {
    return this.request({
      MTI: 1003
    })
  },

  getMessageList (conditions) {
    let cond = Object.assign({ MTI: 1028 }, conditions)
    return this.request(cond)
  },

  deleteMessages (messageList) {
    return this.request({
      MTI: 1031,
      messageList: messageList
    })
  },

  markMessagesAsRead (messageList) {
    return this.request({
      MTI: 1030,
      messageList: messageList
    })
  },

  activateUser (userId) {
    return this.request({
      MTI: 1022,
      userId: userId
    })
  },

  deactivateUser (userId) {
    return this.request({
      MTI: 1022,
      userId: userId
    })
  },

  searchUserRole (conditions) {
    let cond = Object.assign({ MTI: 1022 }, conditions)
    return this.request(cond)
  },

  readUserRole (conditions) {
    let cond = Object.assign({ MTI: 1022 }, conditions)
    return this.request(cond)
  },

  createUserRole (conditions) {
    let cond = Object.assign({ MTI: 1019 }, conditions)
    return this.request(cond)
  },

  updateUserRole (conditions) {
    let cond = Object.assign({ MTI: 1020 }, conditions)
    return this.request(cond)
  },

  deleteUserRole (conditions) {
    let cond = Object.assign({ MTI: 1021 }, conditions)
    return this.request(cond)
  },

  checkUserPermission (conditions) {
    let cond = Object.assign({ MTI: 1011 }, conditions)
    return this.request(cond)
  },

  searchPermission (conditions) {
    let cond = Object.assign({ MTI: 1012 }, conditions)
    return this.request(cond)
  },

  searchUser (conditions) {
    let cond = Object.assign({ MTI: 1023 }, conditions)
    return this.request(cond)
  },

  readUser (conditions) {
    let cond = Object.assign({ MTI: 1023 }, conditions)
    return this.request(cond)
  },

  createUser (conditions) {
    let cond = Object.assign({ MTI: 1024 }, conditions)
    return this.request(cond)
  },

  updateUser (user) {
    return this.request({
      // MTI: 1013,
      MTI: 1025,
      userInfos: user
    })
  },

  signUpdateUser (user) {
    return this.request({
      MTI: 1036,
      userInfos: user
    })
  },

  deleteUser (conditions) {
    let cond = Object.assign({ MTI: 1026 }, conditions)
    return this.request(cond)
  },

  searchBroker (conditions) {
    let cond = Object.assign({ MTI: 1032 }, conditions)
    return this.request(cond)
  },

  readBroker (conditions) {
    let cond = Object.assign({ MTI: 1032 }, conditions)
    return this.request(cond)
  },

  createBroker (conditions) {
    let cond = Object.assign({ MTI: 1033 }, conditions)
    return this.request(cond)
  },

  updateBroker (conditions) {
    let cond = Object.assign({ MTI: 1034 }, conditions)
    return this.request(cond)
  },

  deleteBroker (conditions) {
    let cond = Object.assign({ MTI: 1035 }, conditions)
    return this.request(cond)
  },

  iRiskMonitorUnsubscribeDetail (id, netId) {
    return this.request({
      MTI: 4988,
      isDeleted: 1,
      sorting: id,
      customerOrderId: netId
    })
  },

  iRiskMonitorSubscribeDetail (conditions) {
    let cond = Object.assign({ MTI: 4988 }, conditions)
    return this.request(cond)
  },

  // getDetailInformations (conditions) {
  //   let cond = Object.assign({ MTI: 4988 }, conditions)
  //   return this.request(cond)
  // },

  setBookConfig (conditions) {
    let cond = Object.assign({ MTI: 4989, functionId: 'setBookConfig' }, conditions)
    return this.request(cond)
  },

  getBookConfig (conditions) {
    let cond = Object.assign({ MTI: 4989 }, conditions)
    return this.request(cond)
  },

  exportExcel (conditions) {
    let cond = Object.assign({ MTI: 4989}, conditions)
    return this.request(cond)
  },

  getCategoryConfig (conditions) {
    let cond = Object.assign({ MTI: 4989 }, conditions)
    return this.request(cond)
  },

  getCategoryPlatform (conditions) {
    let cond = Object.assign({ MTI: 4989 }, conditions)
    return this.request(cond)
  },

  getFunctionData (conditions) {
    let cond = Object.assign({ MTI: 4989 }, conditions)
    return this.request(cond)
  },

  getSymbolList (platform) {
    let cond = {
      MTI: 4989,
      functionId: 'getSymbolList',
      parameterList: [{
        paramName: 'platform',
        paramValue: platform
      }]
    }
    return this.request(cond)
  },

  getAccountList (platform) {
    let cond = {
      MTI: 4989,
      functionId: 'getAccountList',
      parameterList: [{
        paramName: 'platform',
        paramValue: platform
      }]
    }
    return this.request(cond)
  },
  getAccountPosition (conditions) {
    let cond = Object.assign({ MTI: 4989, functionId: 'getAccountPosition'}, conditions)
    return this.request(cond)
  },

  getBookTransferList (conditions) {
    let cond = Object.assign({ MTI: 4989, functionId: 'getBookTransferList'}, conditions)
    return this.request(cond)
  },

  validateBookTransfer (conditions) {
    let cond = Object.assign({ MTI: 4989, functionId: 'validateBookTransfer'}, conditions)
    return this.request(cond)
  },

  getBookPlatformName () {
    return this.request({
      MTI: 4989,
      functionId: 'getBookPlatformName'
    })
  },

  getEntityList () {
    return this.request({
      MTI: 4989,
      functionId: 'getEntityList'
    })
  },

  searchConfig (conditions) {
    let cond = Object.assign({ MTI: 1037 }, conditions)
    return this.request(cond)
  },

  createConfig (conditions) {
    let cond = Object.assign({ MTI: 1038 }, conditions)
    return this.request(cond)
  },

  updateConfig (conditions) {
    let cond = Object.assign({ MTI: 1039 }, conditions)
    return this.request(cond)
  },

  deleteConfig (conditions) {
    let cond = Object.assign({ MTI: 1040 }, conditions)
    return this.request(cond)
  },

  getSessionList (conditions) {
    let cond = Object.assign({ MTI: 1042 }, conditions)
    return this.request(cond)
  },

  getContactList () {
    return this.request({
      MTI: 1043
    })
  },

  getReportConfigList () {
    return this.request({
      MTI: 1044
    })
  },
  updateReportConfig (conditions) {
    let cond = Object.assign({ MTI: 1045 }, conditions)
    return this.request(cond)
  },
  sendRequest(conditions) {
    return this.request(conditions)
  },
  sendMTIRequest (mti, conditions) {
    let cond = Object.assign({ MTI: mti }, conditions)
    return this.request(cond)
  },
  sendMTIFunctionRequest (mti, functionId, conditions) {
    let cond = Object.assign({ MTI: mti, functionId:functionId }, conditions)
    return this.request(cond)
  },

  sendFunctionRequest (functionId) {
    return this.request({
      MTI: 4993,
      functionId: functionId
    })
  },

  // getTransactionList (contractId) {
  //   return this.request({
  //     MTI: 1005,
  //     contractId: contractId
  //   })
  // },

})
